import { Module, MutationTree, ActionTree, GetterTree } from "vuex"
import { RootState } from "../../index"
import axios from "axios"

export interface User {
    id: number
    firstName: string
    lastName: string
    email: string
}

export interface UserState {
    userId: string
    userRole: string
    isBasicUser: boolean
    selectedUserId: number | null
    availableUsers: User[]
    isLoading: boolean
}

const state: UserState = {
    userId: "",
    userRole: "",
    isBasicUser: false,
    selectedUserId: null,
    availableUsers: [],
    isLoading: false,
}

const mutations: MutationTree<UserState> = {
    setUserId(state, userId: string) {
        state.userId = userId
    },
    setUserRole(state, userRole: string) {
        state.userRole = userRole
    },
    setIsBasicUser(state, isBasicUser: boolean) {
        state.isBasicUser = isBasicUser
    },
    setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
    },
    setAvailableUsers(state, users: User[]) {
        state.availableUsers = users
    },
    setSelectedUserId(state, userId: number | null) {
        state.selectedUserId = userId
    },
}

const actions: ActionTree<UserState, RootState> = {
    setUser({ commit, rootGetters }) {
        const user = rootGetters["auth/user"]

        if (user) {
            commit("setUserId", user.id)
            commit("setUserRole", user.role)

            if (user.role === "ROLE_USER_BASIC") {
                commit("setIsBasicUser", true)
                commit("setSelectedUserId", parseInt(user.id))
            }
        }
    },

    async fetchAvailableUsers({ commit }) {
        try {
            commit("setLoading", true)

            const response = await axios.get("/setup/available-users")

            commit("setAvailableUsers", response.data.data.users ?? [])
        } catch (error) {
            console.error("Failed to fetch available users:", error)

            commit("setAvailableUsers", [])
        } finally {
            commit("setLoading", false)
        }
    },

    selectUser({ commit, dispatch }, userId: number | null) {
        commit("setSelectedUserId", userId)

        if (userId) {
            dispatch("setup/location/fetchUserLocations", userId, { root: true })
        }
    },
}

const getters: GetterTree<UserState, RootState> = {
    selectedUserId: (state) => state.selectedUserId,
    availableUsers: (state) => state.availableUsers,
    isLoading: (state) => state.isLoading,
    isBasicUser: (state) => state.isBasicUser,
    userId: (state) => state.userId,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
} as Module<UserState, RootState>
